import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AuthorBanner = makeShortcode("AuthorBanner");
const FeedSearch = makeShortcode("FeedSearch");
const Tags = makeShortcode("Tags");
const FeedItems = makeShortcode("FeedItems");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AuthorBanner mdxType="AuthorBanner" />
    <p>{`Faaaala, fiote! Sejam todos muito bem-vindos.`}</p>
    <p>{`Esse aqui é meu espaço para falar umas groselhas sobre tecnologia, programação voltada para o mundo front-end e  ajudar a galera que não sabe o que fazer da vida como dev.`}</p>
    <p>{`Talvez tentando ajudar, eu descubra o que fazer da minha vida também.`}</p>
    <p>{`Fica confortável, rola o feed, utilize as tags pra encontrar algo específico e se tiver dúvidas é só usar uma das minhas redes sociais pra mandar mensagem.`}</p>
    <hr></hr>
    <FeedSearch mdxType="FeedSearch" />
    <Tags mdxType="Tags" />
    <FeedItems mdxType="FeedItems" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      